<template>
  <div
    v-if="isPermittedAll([
      'ComputersGetAll',
    ])"
    class="computers-form-table">
    <!-- Label / Actions -->
    <div class="d-flex align-end">
      <!-- Label -->
      <label class="line-height-1 mb-1">Computers:</label>
      <!-- / Label -->

      <!-- Actions -->
      <div class="ml-auto mb-2 d-flex align-center">
        <!-- Include Hidden -->
        <v-checkbox
          v-if="isPermittedAll([
            'ComputersViewDeleted',
          ])"
          v-model="hiddenStatus"
          @change="getCustomerComputers"
          label="Include Hidden"
          class="mt-0 pt-0"
          true-value="ShowAny"
          false-value="ShowNotHidden"
          hide-details>
        </v-checkbox>
        <!-- / Include Hidden -->

        <!-- Add -->
        <v-btn
          v-if="isPermittedAll([
            'ComputersCreate',
          ])"
          class="square ml-3"
          title="Add Computer"
          type="button"
          color="primary"
          :disabled="$store.getters.isLoadingActive"
          @click="$store.dispatch(
              'openComputerModalForm',
              {
                computer: {
                  CustomerID: customerId,
                },
              },
            )"
          block>
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <!-- / Add -->
      </div>
      <!-- / Actions -->
    </div>
    <!-- / Label / Actions -->

    <!-- Table  -->
     <div style="overflow-y: auto" v-if="isMobile">
      <v-expansion-panels multiple v-model="expanded" class="custom-expansion">  
        <v-expansion-panel
          v-for="(computer, i) in mobileFilteredCustomerComputers"
        >
          <v-expansion-panel-header>
            <div  v-if="expanded.includes(i) === false">
              {{ computer.SerialNumber }}
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div>
              <div>
                <b>Serial Number</b>
                <p>{{ computer.SerialNumber }}</p> 
              </div>
              <div>
                <b>Software</b>
                <p>{{ (computer.SoftwareType || {}).SoftwareTypeName }}</p>
              </div> 
              <div>
                <b>End Date</b>
                <p v-if="computer.SupportContract">
                   {{ computer.SupportContract.SupportContractEndUtc | date}}
                </p> 
                <p v-else  class="error--text">
                   <b>No Contract</b>
                </p>
              </div>
              <div class="d-flex">
                <div>
                  <b>Contract End</b>
                  <p v-if="computer.SupportContract">
                    {{(computer.SupportContract||{}).SupportContractEndUtc | daysUntilDate}} day(s)
                  </p> 
                  <p v-else  class="error--text">
                    <b>No Contract</b>
                  </p> 
                </div>
                <v-btn
                  @click="$store.dispatch(
                    'openComputerModalForm',
                    {
                      computer: {
                        ComputerID: computer.ComputerID,
                      },
                    }
                  )"
                  type="button"
                  color="primary"
                  outlined
                  class="ml-auto align-self-center">
                  Edit
                </v-btn>
              </div>  
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>

    <v-data-table v-else
      class="form-table"
      :headers="computerFields"
      :items="customerComputers"
      mobile-breakpoint="-1"
      item-key="ComputerID"
      dense
      disable-pagination
      hide-default-footer
      fixed-header
      :options="{
        sortBy: ['ComputerName'],
        rowsPerPage: -1,
      }">
      <template
        v-slot:item="row">
        <tr
          :class="{
            'hidden-table-row': row.item.ComputerIsDeleted
          }">
          <td class="action-column">
            <v-btn
              v-if="isPermittedAll([
                'ComputersGetByID',
              ])"
              class="square plain"
              :disabled="$store.getters.isLoadingActive"
              @click="$store.dispatch(
                'openComputerModalForm',
                {
                  computer: {
                    ComputerID: row.item.ComputerID,
                  },
                }
              )">
              <v-icon size="16px">mdi-square-edit-outline</v-icon>
            </v-btn>
          </td>
          <td>{{row.item.SerialNumber}}</td>
          <td>{{(row.item.SoftwareType||{}).SoftwareTypeName}}</td>
          <td
            v-if="row.item.SupportContract">
            {{row.item.SupportContract.SupportContractEndUtc | date}}
          </td>
          <td
            v-if="row.item.SupportContract">
            {{(row.item.SupportContract||{}).SupportContractEndUtc | daysUntilDate}} day(s)
          </td>
          <td
            colspan="2"
            class="error--text"
            v-else>
            <b>No Contract</b>
          </td>
        </tr>
      </template>
    </v-data-table>
    <!-- / Table  -->
  </div>
</template>

<script>
import EventBus from '../event-bus';

export default {
  name: 'CustomerComputersFormTable',
  props: [
    'customerId',
  ],
  data() {
    return {
      expanded: [],
      hiddenStatus: 'ShowNotHidden',
      customerComputers: [],
      mobileFilteredCustomerComputers: [],
      computerFields: [
        {
          text: '',
          value: 'action',
          sortable: false,
          class: 'action-column',
        },
        {
          text: 'Serial Number',
          value: 'SerialNumber',
        },
        {
          text: 'Software',
          value: 'SoftwareTypeName',
        },
        {
          text: 'End Date',
          value: 'SupportContract.SupportContractEndUtc',
        },
        {
          text: 'Contract End',
          value: 'SupportContract.SupportContractEndUtc',
        },
      ],
    };
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  methods: {
    getCustomerComputers() {
      this.$store.dispatch('getCustomerComputers', {
        params: {
          HiddenStatus: this.hiddenStatus,
          CustomerID: this.customerId,
        },
      }).then((customerComputers) => {
        this.customerComputers = customerComputers;
        if (this.customerComputers ) {
          this.mobileFilteredCustomerComputers = this.customerComputers;

          if (this.hiddenStatus === 'ShowNotHidden') {
             this.mobileFilteredCustomerComputers.filter(x => x.ComputerIsDeleted === false)
          }
        }

      });
    },
  },
  created() {
    this.getCustomerComputers();
    EventBus.$on('getCustomerComputers', this.getCustomerComputers);
  },
  destroyed() {
    EventBus.$off('getCustomerComputers', this.getCustomerComputers);
  }, 
};
</script>

<style lang="scss"></style>
